function initCustomOptionsPopups(root = document) {
  root.querySelectorAll('[data-custom-options-modal]').forEach((modal) => {
    if (modal.dataset.movedToBody === 'true') return;

    document.body.appendChild(modal);
    modal.dataset.movedToBody = 'true';
  });

  root.querySelectorAll('[data-custom-options-open]').forEach((button) => {
    if (button.dataset.bound === 'true') return;

    button.addEventListener('click', () => {
      const popupId = button.dataset.customOptionsOpen;
      const popup = document.getElementById(popupId);

      if (!popup) return;

      popup.classList.remove('invisible');
      popup.setAttribute('open', '');

      initCustomOptionsNav(popup);
    });

    button.dataset.bound = 'true';
  });

  root.querySelectorAll('[data-custom-options-modal] .js-close-modal').forEach((button) => {
    if (button.dataset.bound === 'true') return;

    button.addEventListener('click', () => {
      const popup = button.closest('[data-custom-options-modal]');

      if (!popup) return;

      popup.classList.add('invisible');
      popup.removeAttribute('open');
    });

    button.dataset.bound = 'true';
  });
}

function initCustomOptionsNav(root = document) {
  const navLinks = root.querySelectorAll('.tm-custom-page .tm-nav a[href^="#"]');

  if (!navLinks.length) return;

  const sections = Array.from(navLinks)
    .map((link) => {
      const id = link.getAttribute('href');
      const section = root.querySelector(id);

      return section ? { link, section } : null;
    })
    .filter(Boolean);

  if (!sections.length) return;

  const scrollContainer =
    root.querySelector('.modal__window') ||
    root.querySelector('.modal__content') ||
    root;

  function setActiveLink() {
    let active = sections[0];

    sections.forEach((item) => {
      const rect = item.section.getBoundingClientRect();
      const containerRect =
        scrollContainer === window
          ? { top: 0 }
          : scrollContainer.getBoundingClientRect();

      if (rect.top - containerRect.top <= 180) {
        active = item;
      }
    });

    navLinks.forEach((link) => link.classList.remove('is-active'));

    if (active) {
      active.link.classList.add('is-active');
    }
  }

  navLinks.forEach((link) => {
    if (link.dataset.bound === 'true') return;

    link.addEventListener('click', (event) => {
  event.preventDefault();

  const target = root.querySelector(link.getAttribute('href'));
  if (!target) return;

  target.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });

  navLinks.forEach((item) => item.classList.remove('is-active'));
  link.classList.add('is-active');
});

    link.dataset.bound = 'true';
  });

  setActiveLink();

  if (scrollContainer.dataset.navBound !== 'true') {
    scrollContainer.addEventListener('scroll', setActiveLink, { passive: true });
    scrollContainer.dataset.navBound = 'true';
  }
}

document.addEventListener('DOMContentLoaded', () => {
  initCustomOptionsPopups();
});

document.addEventListener('shopify:section:load', (event) => {
  initCustomOptionsPopups(event.target);
});